module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Not Found")]), _vm._v(" "), _c('p', [_vm._v("\n                It looks like the content you tried to access is not available. You can navigate to the "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Homepage")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "mailto:ops@leadscorz.com"
    }
  }, [_vm._v("Contact Us")]), _vm._v(" if you believe this is a mistake.\n            ")], 1), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" Navigate to Homepage")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-072cc168"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 604
// module chunks = 0